import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native-web";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import moment from "moment-timezone";
//components
import DropdownMenuPopover from "../../../components/dropdown/DropdownPopover";
import PageButtonNavigate from "../../../components/button/PageButtonNavigate";
import { EditButton } from "../../../components/button/IconButton";
import EmptyList from "../../../components/pages/EmptyList";
//images
import noImage from "../../../asset/images/register/user.png";
//functions
import { formatNumber } from "../../../functions/format/numberFormat";
import useSelection from "antd/es/table/hooks/useSelection";
import { isAdmin } from "../../../functions/validate/validate";
import { useSelector } from "react-redux";

const MoveTeamPathTable = (props) => {
  const { tableHeader = [], tableData = [] } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const userInfo = useSelector((state) => {
    return state.user;
  });

  const pagesCount = Math.ceil(tableData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const tableDataSliced = tableData.slice(startIndex, endIndex);

  const { onSelect } = props;

  const renderMenu = (row) => {
    let init = [];
    if (!row) {
      return init;
    }
    if (row.active === "Y" || row.active === "W") {
      init.push({ label: "ระงับการใช้งาน", value: "inActiveUser" });
    } else if (row.active === "N") {
      init.push({ label: "เปิดสิทธิใช้งาน", value: "activeUser" });
    }
    if (row.active !== "D") {
      init.push({ label: "แก้ไขข้อมูล", value: "edit" });
      init.push({ label: "ลบผู้ใช้งาน", value: "delete" });
      init.push({ label: "ย้ายทีม", value: "moveTeam" });
    }
    return init;
  };

  const renderActive = (row) => {
    switch (row.active) {
      case "Y":
        return "ปกติ";
      case "N":
        return "ระงับการใช้งาน";
      case "W":
        return "ยังไม่เปิดรายการขาย";
      case "D":
        return "ลบผู้ใช้งาน";
      default:
        return "-";
    }
  };

  return (
    <React.Fragment>
      {tableDataSliced.length > 0 ? (
        <View style={{ width: "100%", height: "100%" }}>
          <TableContainer sx={styles.tableContainer}>
            <Table sx={styles.table}>
              <TableHead sx={{ position: "sticky", top: 0, zIndex: 9999 }}>
                <TableRow style={{ width: "100%", backgroundColor: "#FFF" }}>
                  <TableCell sx={{ ...styles.headerCell }}>
                    วันที่ย้ายออก
                  </TableCell>
                  <TableCell sx={{ ...styles.headerCell }}>ย้ายออก</TableCell>
                  <TableCell sx={{ ...styles.headerCell }}>
                    วันที่ย้ายเข้า
                  </TableCell>
                  <TableCell sx={{ ...styles.headerCell }}>ย้ายเข้า</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableDataSliced.map((row) => (
                  <TableRow key={row.id} sx={styles.tableRow}>
                    <TableCell sx={styles.tableCell}>
                      {" "}
                      <Text>{row.name ? row.name : ""}</Text>
                    </TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Text>
                        {row.locationProduct ? row.locationProduct : "-"}
                      </Text>
                    </TableCell>{" "}
                    <TableCell sx={styles.tableCell}>
                      <Text>ยังไม่จัดอันดับ</Text>
                    </TableCell>{" "}
                    <TableCell sx={styles.tableCell}>
                      <Text>ยังไม่จัดอันดับ</Text>
                    </TableCell>{" "}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <PageButtonNavigate
            currentPage={currentPage}
            pagesCount={pagesCount}
            startIndex={startIndex}
            endIndex={endIndex}
            dataCount={tableData.length}
            onSelectPage={(page) => {
              setCurrentPage(page);
            }}
          />
        </View>
      ) : (
        <EmptyList title={"ยังไม่มีรายการ"} />
      )}
    </React.Fragment>
  );
};

const styles = {
  tableContainer: {
    overflowY: "scroll",
    scrollbarWidth: "thin",
    scrollbarColor: "#c7c7c7 #f5f5f5",
    flex: 1,
  },
  table: {
    border: "none",
    minWidth: 650,
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(255, 241, 241, 1)",
    },
  },
  tableCell: {
    borderBottom: "none",
    whiteSpace: "nowrap",
    wordBreak: "break-word",
  },
  headerCell: {
    color: "rgba(165, 88, 90, 1)",
    whiteSpace: "nowrap",
  },
};

export default MoveTeamPathTable;
